import { useEffect, useState, useRef, useCallback } from "react";
import { GetDataFromApiWithParams } from "../../../../../services/api/ExecuteApiRequests";
import IPDCFinalTable from "../../../../../components/IPDCFinalTable";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";

export default function ApproveImportedSpatialInfo() {
  const [occupancypermitlist, setoccupancypermitlist] = useState([]);
  const componentRef = useRef();
  const [selectedColumnsSplitMerge, setSelectedColumnsSplitMerge] = useState([]);
  const [loading, setLoading] = useState(true);
  const [retrieve, setRetrieve] = useState(true);

  const navigate = useNavigate();

  // Utility: convert nested objects to strings
  const stringifyNestedObjects = (dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => {
      const newItem = {};
      Object.keys(item).forEach(key => {
        newItem[key] = (typeof item[key] === "object" && item[key] !== null)
          ? JSON.stringify(item[key])
          : item[key];
      });
      return newItem;
    });
  };

  // Handle navigation to generate occupancy permit certificate page
  const handleIssuePermit = useCallback((row) => {
    console.log("Opening generate occupancy permit page for row:", row);
    
    // Navigate to the generate occupancy permit certificate page
    navigate("/generateoccupancypermitcertificate", {
      state: {
        permitData: row,
        // Pass the entire row object as state
        ...row
      }
    });
  }, [navigate]);

  // Add action columns - ONLY Issue Permit button
  const addActionColumnsSplitMerge = useCallback((dataArray) => {
    if (!dataArray || !Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => ({
      ...item,
      issuePermit: (
        <Button 
          variant="contained" 
          color="primary" 
          size="small"
          onClick={() => handleIssuePermit(item)}
          sx={{ 
            whiteSpace: 'nowrap', 
            minWidth: '120px',
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0',
            }
          }}
        >
          Issue Permit
        </Button>
      )
    }));
  }, [handleIssuePermit]);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      
      try {
        // Fetch occupancy permit Data
        const occupancypermit = await GetDataFromApiWithParams("/occupancyPermits");
        
        if (occupancypermit && Array.isArray(occupancypermit) && occupancypermit.length > 0) {
          console.log("Raw occupancy permits data:", occupancypermit);
          
          const formattedSplitMergeData = stringifyNestedObjects(occupancypermit);
          const occupancyPermitData = addActionColumnsSplitMerge(formattedSplitMergeData);
          setoccupancypermitlist(occupancyPermitData);
          
          // Get base columns (excluding action columns that will be added by IPDCFinalTable)
          const baseSplitMergeColumns = formattedSplitMergeData.length > 0 
            ? Object.keys(formattedSplitMergeData[0]).filter(col => col !== 'issuePermit')
            : [];
          
          // Set columns: ONLY issuePermit button
          setSelectedColumnsSplitMerge([...baseSplitMergeColumns, "issuePermit"]);
          
          console.log("Processed occupancy permits data:", occupancyPermitData);
        } else {
          console.log("No occupancy permits data found");
          setoccupancypermitlist([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load data. Please try again.", {
          position: "top-right",
          autoClose: 8000
        });
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [addActionColumnsSplitMerge]);

  return (
    <Box sx={{ p: 2 }}>
      <ToastContainer 
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>Loading Data</div>
      ) : (
        <>
          <div style={{ 
            borderBottom: '2px solid #e0e0e0', 
            margin: '30px 0',
            width: '100%' 
          }} />

          <div>
            <h3 style={{ marginBottom: '15px', color: '#333' }}>Occupancy Permit List</h3>
            
            {occupancypermitlist.length > 0 ? (
              <IPDCFinalTable
                ref={componentRef}
                data={occupancypermitlist}
                setData={setoccupancypermitlist}
                selectedColumns={selectedColumnsSplitMerge}
                title="Occupancy Permit Lists"
                attachmentLink="file_path"
                hasAttachment={false}
              />
            ) : (
              <div style={{ 
                padding: '20px', 
                backgroundColor: '#f5f5f5', 
                borderRadius: '4px',
                textAlign: 'center',
                color: '#666'
              }}>
                No occupancy permit applications found
              </div>
            )}
          </div>
        </>
      )}
    </Box>
  );
}